import { ENABLE_DEBUG_LOG } from "config";

import "animate.css/animate.min.css";
import "react-toastify/dist/ReactToastify.css";

export const formatThousand = (num) => {
  // eslint-disable-next-line no-param-reassign
  num = Number(num);
  if (Math.abs(num) >= 1e9) {
    return `${Math.abs(num / 1e9).toFixed(2)}b`;
  }
  if (Math.abs(num) >= 1e6) {
    return `${Math.abs(num / 1e6).toFixed(2)}m`;
  }
  if (Math.abs(num) > 1e3) {
    return `${Math.abs(num / 1e3).toFixed(2)}k`;
  }
  return num.toFixed(2);
};
export const formatThousandNoLocale = (num) => {
  // eslint-disable-next-line no-param-reassign
  num = Number(num);
  if (Math.abs(num) >= 1e9) {
    return `${Math.abs(num / 1e9).toFixed(0)}b`;
  }
  if (Math.abs(num) >= 1e6) {
    return `${Math.abs(num / 1e6).toFixed(0)}m`;
  }
  if (Math.abs(num) > 1e3) {
    return `${Math.abs(num / 1e3).toFixed(0)}k`;
  }
  return num.toFixed(2);
};
/* eslint-disable-next-line no-console */
export const debugLog = (...logs) => ENABLE_DEBUG_LOG && console.log(...logs);

export const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const formatDate = (timestamp, showDate = false, showTime = false) => {
  const date = new Date(timestamp);
  const dayName = days[date.getDay()];
  const day = `0${date.getDate()}`.slice(-2);
  const month = date.getMonth();
  // const year = date.getFullYear();
  const hours = `0${date.getHours()}`.slice(-2);
  const minutes = `0${date.getMinutes()}`.slice(-2);
  const seconds = `0${date.getSeconds()}`.slice(-2);

  if (showTime) {
    return `${
      showDate ? `${dayName}, ${day} ${months[month]}` : ""
    }${hours}:${minutes}:${seconds}`;
  }
  return `${showDate ? `${day} ${months[month]}` : ""}`;
};
